import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import routes from './routes';

import { state } from '@/state/modules/authfack.js';
import { clearInfoUser } from '@/api/handler/main';

Vue.use(VueRouter);
Vue.use(VueMeta, {
    keyName: 'page'
});

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((routeTo, routeFrom, next) => {
    const conditionRemoveTabEditOfCampaign =
        !(routeFrom.name === 'CampaignEdit' && routeTo.name === 'CampaignView') &&
        !(routeFrom.name === 'CampaignView' && routeTo.name === 'CampaignEdit');
    if (conditionRemoveTabEditOfCampaign) {
        localStorage.removeItem('TabEdit');
    }
    // const conditionRemoveSearchListOfCampaign =
    //     !(routeFrom.name === 'Campaign' && routeTo.name === 'CampaignView') &&
    //     !(routeFrom.name === 'CampaignView' && routeTo.name === 'Campaign');
    // if (conditionRemoveSearchListOfCampaign) {
    //     localStorage.removeItem('BookmarkCampaign');
    // }

    const publicPages = ['/login', '/register', '/forgot-password', '/reset-password'];
    const authpage = publicPages.includes(routeTo.path);
    const loggeduser = JSON.parse(localStorage.getItem('user'));
    const token = window.$cookies.get('token');
    const expireTime = localStorage.getItem('expireTime');

    if (!token || !expireTime || Date.now() > expireTime) {
        if (!authpage) {
            localStorage.setItem('redirectAfterLogin', routeTo.fullPath);
            return next('/login');
        }
        if (loggeduser) {
            clearInfoUser();
        }
    } else {
        if (!loggeduser) {
            clearInfoUser();
            if (!authpage) {
                localStorage.setItem('redirectAfterLogin', routeTo.fullPath);
                return next('/login');
            }
        } else {
            if (authpage) {
                return next('/');
            }
        }
    }
    next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
    // Create a `beforeResolve` hook, which fires whenever
    // `beforeRouteEnter` and `beforeRouteUpdate` would. This
    // allows us to ensure data is fetched even when params change,
    // but the resolved route does not. We put it in `meta` to
    // indicate that it's a hook we created, rather than part of
    // Vue Router (yet?).
    try {
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        if (args.length) {
                            next(...args);
                            reject(new Error('Redirected'));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    resolve();
                }
            });
        }
    } catch (error) {
        return;
    }
    next();
});

router.afterEach((to) => {
    const redirect404Paths = routes.map((route) => route.path);

    if (!redirect404Paths.includes(to.path)) {
        router.push({
            path: '/error-page'
        });
    } else {
        if (to.meta.roleDefault === 'all') return;
        if (!state.user?.role?.permissions || !to.meta?.role) return;
        const hasExistRouter = state.user.role.permissions.some((permission) => to.meta.role.includes(permission.name));
        if (hasExistRouter) return;
        router.push({
            path: '/error-page'
        });
    }
});

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        const lastReload = sessionStorage.getItem('last-chunk-loader-error');
        const now = Date.now();
        // Chỉ cho phép reload nếu chưa reload trong vòng 10 giây qua (tránh loop)
        if (!lastReload || now - (lastReload || 0) > 10000) {
            sessionStorage.setItem('last-chunk-loader-error', now);
            window.location.href = targetPath || window.location.href;
        }
    }
});

export default router;
